import React from 'react';
type Props = {
  tone?: 'light' | 'dark' | 'parchment';
  className?: string;
};

/** Full-width horizontal hairline that meets the vertical content rails. */
export function GridDivider({
  tone = 'light',
  className = ''
}: Props) {
  const line = tone === 'dark' ? 'bg-[rgba(170,185,210,0.09)]' : tone === 'parchment' ? 'bg-parchment-line' : 'bg-mist-line';
  return <div aria-hidden="true" className={`pointer-events-none relative z-[6] h-px w-full ${line} ${className}`} data-id="element-231" data-mp="23wso0vkz2y6w" />;
}